import throttle from "OK/utils/throttle";
import {StatLogger} from 'OK/StatLogger';

const DATA_CONTAINER = 'data-container';
const DATA_HEIGHT = 'data-height';
const DATA_ACTIVATE_HEIGHT = 'data-activate-height';
const CSS_ACTIVE = '__active';
const CSS_HIDDEN = '__hidden';
const CSS_BOTTOM = '__bottom';

export class FixedTopBock {
    private element!: HTMLElement;
    private id!: string;
    private showBottom: boolean = false;
    private container: HTMLElement | null = null;
    private containerIsWindow: boolean = false;
    private scrollToTopHeight!: number;
    private activateHeight!: number;
    private scrollToBottomHeight!: number;
    private scrollStartTime: number = 0;
    private lastScrollTopPosition: number = 0;
    private boundScrollHandler!: () => void;
    private useHeightComponentSelector!: string;

    private arrowButton: HTMLDivElement | null = null;
    private arrowIsBottom: boolean = false;
    private statLogger!: StatLogger;

    constructor() {}

    activate(element: HTMLElement) {
        this.element = element;
        this.id = this.element.getAttribute("id")!;
        this.showBottom = this.element.hasAttribute(DATA_CONTAINER);
        if (this.showBottom) {
            this.container = document.getElementById(this.element.getAttribute(DATA_CONTAINER)!)!
        } else {
            this.containerIsWindow = true;
        }

        if (!this.container && !this.containerIsWindow) {
            return;
        }

        this.scrollToTopHeight = parseInt( this.element.getAttribute(DATA_HEIGHT) || '0', 10);
        this.activateHeight = parseInt(this.element.getAttribute(DATA_ACTIVATE_HEIGHT) || '500', 10);
        this.scrollToBottomHeight = this.scrollToTopHeight;
        this.scrollStartTime = 0;
        this.lastScrollTopPosition = 0;
        this.useHeightComponentSelector = this.element.getAttribute('data-use-height-component-selector')!;

        this.boundScrollHandler = throttle(10, this.onScroll);

        this.arrowButton = this.element.querySelector('.scroll-arrow')!;
        this.arrowButton.addEventListener('click', this.onClick);
        this.arrowButton.addEventListener('mouseenter', this.onMouseEnter);
        this.arrowButton.addEventListener('mouseleave', this.onMouseLeave);

        if (this.containerIsWindow) {
            window.addEventListener('scroll', this.boundScrollHandler);
        } else {
            this.container?.addEventListener('scroll', this.boundScrollHandler);
        }

        this.statLogger = new StatLogger(`fixed.top.block.${this.id ? this.id + '.' : ''}`);
    }

    getScrollTop = (): number => {
        return this.containerIsWindow ? window.pageYOffset : this.container!.scrollTop;
    }

    setScrollTop = (value: number): void => {
        if (this.containerIsWindow) {
            window.scrollTo(0, value);
        } else {
            this.container!.scrollTop = value;
        }
    }

    onMouseEnter = () => {
        if (this.arrowIsBottom && this.getScrollTop() >= this.scrollToTopHeight) {
            this.element.classList.remove(CSS_HIDDEN);
        }
    }

    onMouseLeave = () => {
        if (this.arrowIsBottom) {
            this.element.classList.add(CSS_HIDDEN);
        }
    }

    hide = (): void => {
        this.element.classList.remove(CSS_ACTIVE);
    }

    onScroll = () => {
        if (this.useHeightComponentSelector) {
            const useHeightComponent = document.querySelector(this.useHeightComponentSelector);
            if (useHeightComponent) {
                this.element.style.top = useHeightComponent.getBoundingClientRect().height + 16 + "px";
            }
        }

        const scrollTopPosition = this.getScrollTop();

        this.lastScrollTopPosition = scrollTopPosition;

        if (scrollTopPosition > this.activateHeight + 50) {
            this.element.classList.add(CSS_ACTIVE);
            this.element.classList.remove(CSS_HIDDEN);
            this.arrowButton?.classList.remove(CSS_BOTTOM);
            this.element.offsetTop;
            this.arrowIsBottom = false;
        } else if (scrollTopPosition < this.activateHeight && !this.arrowIsBottom) {
            this.hide();
        }
    }

    onClick = () => {
        this.statLogger.success('click');
        if (this.arrowIsBottom) {
            this.setScrollTop(this.scrollToBottomHeight);
            this.arrowButton?.classList.remove(CSS_BOTTOM);
            this.arrowIsBottom = false;
        } else {
            this.scrollToBottomHeight = this.getScrollTop();
            this.setScrollTop(this.scrollToTopHeight);
            if (this.showBottom) {
                this.arrowButton?.classList.add(CSS_BOTTOM);
                this.arrowIsBottom = true;
            }
        }
    }

    deactivate = () => {
        this.element.classList.remove(CSS_ACTIVE);

        if (!this.container && !this.containerIsWindow) {
            return;
        }

        if (this.arrowButton) {
            this.arrowButton.removeEventListener('click', this.onClick);
            this.arrowButton.removeEventListener('mouseenter', this.onMouseEnter);
            this.arrowButton.removeEventListener('mouseleave', this.onMouseLeave);
        }

        if (this.containerIsWindow) {
            window.removeEventListener('scroll', this.boundScrollHandler);
        } else {
            this.container?.removeEventListener('scroll', this.boundScrollHandler);
        }

        this.arrowButton = null;
        this.container = null;
    }
}
